import { render } from "./Regulasi.vue?vue&type=template&id=7ae9d660"
import script from "./Regulasi.vue?vue&type=script&lang=js"
export * from "./Regulasi.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__